'use strict';

var _ = require('underscore');
var swUtils = require('js/lib/sw-utils');
var ACTION_TYPES = require('../actionTypes');
var combineReducers = require('js/lib/sw-redux/utils/combineReducers');
var STATICS = require('../statics');
///////////
// HOTSPOTS
///////////
function ensureHotspots(hotspots) {
  return hotspots || {};
}

function setCurrentHotspotIdReducer(currentHotspotId, action) {
  var defaultId = -1;
  currentHotspotId = _.isUndefined(currentHotspotId) ? defaultId : currentHotspotId;

  if (ACTION_TYPES.SELECT_HOTSPOT === action.type) {
    currentHotspotId = _.isUndefined(action.hotspotId) ? defaultId : action.hotspotId;
  }

  return currentHotspotId;
}

/**
 * Makes sure hotspot values are valid.
 * Will only return hotspot values that have changed
 *
 * @param newHotspot
 * @return {{}}
 */
function ensureHotspotInfo(newHotspot) {
  var _newHotspot = {
    height: parseFloat(newHotspot.height),
    font_size: parseFloat(newHotspot.font_size),
    line_height: parseFloat(newHotspot.line_height)
  };

  if (!_.isNumber(_newHotspot.font_size) || _.isNaN(_newHotspot.font_size)) {
    _newHotspot.font_size = void 0;
  }

  if (!_.isNumber(_newHotspot.line_height) || _.isNaN(_newHotspot.line_height)) {
    _newHotspot.line_height = void 0;
  }

  if (!_.isUndefined(_newHotspot.font_size) && _newHotspot.font_size > _newHotspot.height) {
    _newHotspot.font_size = _newHotspot.height;
  }

  if (!_.isUndefined(_newHotspot.line_height) && _newHotspot.line_height > _newHotspot.height) {
    _newHotspot.line_height = _newHotspot.height;
  }

  return _newHotspot;
}

function addOrUpdateHotspot(hotspots, action) {
  var newHotspotData;
  var newHotspot;
  var oldHotspot;

  // Make sure we have at leat an object for a hotspot
  hotspots = ensureHotspots(hotspots);

  if (action.hotspotData && action.hotspotData.hotspotId) {
    hotspots = swUtils.cloneDataObject(hotspots);
    newHotspotData = swUtils.cloneDataObject(action.hotspotData);
    oldHotspot = hotspots[newHotspotData.hotspotId];
    oldHotspot = oldHotspot ? swUtils.cloneDataObject(oldHotspot) : {};
    // make new hotspot object
    newHotspot = _.extend({}, oldHotspot, newHotspotData);
    // make sure it has valid values
    newHotspot = _.extend({}, newHotspot, ensureHotspotInfo(newHotspot));
    hotspots[newHotspotData.hotspotId] = newHotspot;
  }

  return hotspots;
}

function removeHotspot(hotspots, action) {
  hotspots = ensureHotspots(hotspots);


  if (action.hotspotId) {
    hotspots = swUtils.cloneDataObject(hotspots);
    delete hotspots[action.hotspotId];
  }

  return hotspots;
}

function hotspotsReducer(hotspots, action) {

  hotspots = ensureHotspots(hotspots);

  switch (action.type) {
    case ACTION_TYPES.ADD_HOTSPOT:
    case ACTION_TYPES.UPDATE_HOTSPOT:
      return addOrUpdateHotspot(hotspots, action);
    case ACTION_TYPES.REMOVE_HOTSPOT:
      return removeHotspot(hotspots, action);
  }

  return hotspots;
}

///////////
// INPUT MODE
///////////


///////////
// MODEL INFO
///////////
function modelIdReducer(modelId, action) {
  if (_.isUndefined(modelId)) {
    modelId = -1;
  }

  if (ACTION_TYPES.CHANGE_MODEL_ID === action.type && !_.isUndefined(action.modelId)) {
    modelId = action.modelId;
  }

  return modelId;
}

function modelUrlReducer(modelUrl, action) {
  if (_.isUndefined(modelUrl)) {
    modelUrl = '';
  }

  if (ACTION_TYPES.CHANGE_MODEL_URL === action.type && !_.isUndefined(action.modelUrl)) {
    modelUrl = action.modelUrl;
  }

  return modelUrl;
}

function modelRotationReducer(modelRotation, action) {
  if (_.isUndefined(modelRotation)) {
    modelRotation = {};
  }

  if (ACTION_TYPES.CHANGE_MODEL_URL === action.type && !_.isUndefined(action.modelRotation)) {
    modelRotation = action.modelRotation;
  }

  return modelRotation;
}

function modelRespolutionReducer(modelResolution, action) {
  if (_.isUndefined(modelResolution)) {
    modelResolution = 0.2;
  }

  if (ACTION_TYPES.CHANGE_RESOLUTION === action.type && !_.isUndefined(action.modelResolution)) {
    modelResolution = action.modelResolution;
  }

  return modelResolution;
}

///////////
// INPUT MODE
///////////
function preventInputReducer(preventInput, action) {

  if (_.isUndefined(preventInput)) {
    preventInput = false;
  }

  if (action.type === ACTION_TYPES.CHANGE_PREVENT_INPUT) {
    preventInput = !!action.preventInput;
  }

  return preventInput;
}

///////////
// VIEW MODE
///////////
function isPreviewingReducer(isPreviewing, action) {

  if (_.isUndefined(isPreviewing)) {
    isPreviewing = true;
  }

  switch (action.type) {
    case ACTION_TYPES.SHOW_SHAPE_JS_VIEW:
      return true;
    case ACTION_TYPES.SHOW_X3DOM_VIEW:
      return false;
    case ACTION_TYPES.TOGGLE_IS_PREVIEWING:
      return !isPreviewing;
  }

  return isPreviewing;
}

function waitingForViewerReducer(waitingForViewer, action) {

  switch (action.type) {
    case ACTION_TYPES.WAIT_FOR_VIEWER:
      return true;
    case ACTION_TYPES.STOP_WAITING_FOR_VIEWER:
      return false;
  }

  return _.isUndefined(waitingForViewer) ? false : waitingForViewer;
}

function viewModeReducer(viewMode, action) {
  if (_.isUndefined(viewMode)) {
    viewMode = STATICS.INIT_DATA.viewMode;
  }

  if (ACTION_TYPES.SET_VIEW_MODE && !_.isUndefined(action.viewMode)) {
    return action.viewMode;
  }

  return viewMode;
}

function formActionsReducer(formActions, action) {
  if (_.isUndefined(formActions)) {
    formActions = STATICS.INIT_DATA.formActions;
  }

  if (ACTION_TYPES.SET_VIEW_MODE && !_.isUndefined(action.formActions)) {
    return action.formActions;
  }

  return formActions;
}

function boxModeReducer(boxMode, action) {

  if (ACTION_TYPES.CHANGE_BOX_MODE && !_.isUndefined(action.boxMode)) {
    return action.boxMode;
  }

  return _.isUndefined(boxMode) ? null : boxMode;
}

function backboneModelReducer(customMakerData, action) {
  var hasChanged = false;

  if (_.isObject(action.attrs)) {
    _.each(action.attrs, function (val, key) {

      // if things are the same don't do anything
      if (val === customMakerData[key]) {
        return;
      }

      // Make a new object if were here and nothing has changed yet
      customMakerData = !hasChanged ? _.extend({}, customMakerData) : customMakerData;

      // change the values
      if (_.isArray(val) || _.isObject(val)) {
        customMakerData[key] = swUtils.cloneDataObject(val);
      } else {
        customMakerData[key] = val;
      }

      //mark that things have changed
      hasChanged = true;

    });
  }

  return customMakerData;
}

function idReducer(id, action) {
  if (ACTION_TYPES.CHANGE_BOX_MODE && !_.isUndefined(action.id)) {
    return action.id;
  }

  return _.isUndefined(id) ? '' : id;
}

var combinedReducers = combineReducers({

  id: idReducer,
  boxMode: boxModeReducer,
  formActions: formActionsReducer,
  currentHotspotId: setCurrentHotspotIdReducer,
  hotspots: hotspotsReducer,
  isPreviewing: isPreviewingReducer,
  modelId: modelIdReducer,
  model: modelUrlReducer,
  modelRotation: modelRotationReducer,
  preventAllInput: preventInputReducer,
  resolution: modelRespolutionReducer,
  waitingForViewer: waitingForViewerReducer,
  viewMode: viewModeReducer

});

module.exports = function customMakerReducer(customMakerData, action) {
  if (action.type === ACTION_TYPES.BACKBONE_MODEL_SET) {
    return backboneModelReducer(customMakerData, action);
  } else {
    return combinedReducers(customMakerData, action);
  }
};

